import { RPCs } from "../../../services/rpc.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { ALL_LOCATIONS_ID } from "../constants.js";
import { useRegionScope } from "../../../contexts/RegionScopeContext.js";
import "react";
import { Button, ColorSquare } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { atom, useAtom } from "jotai";
//#region src/modules/Locations/shared/SelectLocationAndGroup.tsx
var activeGroupAtom = atom("location");
var ADDITIONAL_OPTIONS = [{ id: ALL_LOCATIONS_ID }];
var SelectedSingle = ({ color, label }) => /* @__PURE__ */ jsxs("div", {
	className: "mx-sm gap-x-sm inline-flex items-center",
	children: [!!color && /* @__PURE__ */ jsx(ColorSquare, { color }), /* @__PURE__ */ jsx("div", {
		className: "truncate text-sm",
		children: label
	})]
});
var SelectedMulti = ({ color, label }, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "px-sm flex max-w-full items-center",
		children: [!!color && /* @__PURE__ */ jsx(ColorSquare, {
			color,
			marginRight: true
		}), /* @__PURE__ */ jsx("div", {
			className: "truncate text-sm",
			children: label
		})]
	})
});
var ListItem = ({ address, color, label }) => /* @__PURE__ */ jsxs("div", {
	className: "inline-flex w-full items-center justify-between",
	children: [/* @__PURE__ */ jsxs("div", {
		className: "truncate",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate text-sm",
			children: label
		}), address?.streetAddress && /* @__PURE__ */ jsxs("div", {
			className: "text-color-subtle truncate text-sm",
			children: [/* @__PURE__ */ jsxs("span", {
				className: "truncate font-medium",
				children: [
					address?.streetAddress,
					",",
					" "
				]
			}), address?.locality]
		})]
	}), !!color && /* @__PURE__ */ jsx(ColorSquare, { color })]
});
var MenuList = ({ children }) => {
	const [activeGroup, setActiveGroup] = useAtom(activeGroupAtom);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
		className: "space-x-xs bg-surface-strong p-xs sticky top-0 flex",
		children: [/* @__PURE__ */ jsx(Button, {
			className: classnames({ "bg-main-faded": activeGroup === "location" }, "flex-1"),
			disabled: activeGroup === "location",
			fullWidth: true,
			onClick: () => {
				if (setActiveGroup) setActiveGroup("location");
			},
			subtle: true,
			variant: "main",
			children: "Locations"
		}), /* @__PURE__ */ jsx(Button, {
			className: classnames({ "bg-main-faded": activeGroup === "location-group" }, "flex-1"),
			disabled: activeGroup === "location-group",
			onClick: () => {
				if (setActiveGroup) setActiveGroup("location-group");
			},
			subtle: true,
			variant: "main",
			children: "Groups"
		})]
	}), children] });
};
var responseOptionsExtractor = (data) => data?.locationsAndGroups;
var SelectLocationAndGroup = ({ allowAllOption, idFilter, limit = 25, multi, regionIds, value, ...atalayaSelectProps }) => {
	const [activeGroup] = useAtom(activeGroupAtom);
	const regionScope = useRegionScope();
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderMenuList: MenuList,
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		additionalOptions: allowAllOption ? ADDITIONAL_OPTIONS : void 0,
		args: {
			active: true,
			idFilter,
			regionIds: regionIds ?? regionScope,
			typeFilter: activeGroup
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ label }) => label,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Locations.GetLocationsAndGroupsLabelsList.v1,
		requestFilterProp: "idFilter",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectLocationAndGroup };

//# sourceMappingURL=SelectLocationAndGroup.js.map